import { UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
import { Popup } from "antd-mobile";
import style from "css/hotdesking.module.css";
import { ReactComponent as CalendarIcon } from "asset/hotdesking/calendar.svg";
import { ReactComponent as TimeIcon } from "asset/hotdesking/time.svg";
import React from "react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

function BookInfo({ book, resource, isOpen, onClose }) {
  const { t, i18n } = useTranslation();
  const type = {
    AVAILABLE: {
      value: "AVAILABLE",
      label: t("HOTDESKING.SEAT_GUIDE.RESERVED"),
      color: "#f16569",
      hover: "#eb1c22",
      blur: "#f16569cc",
    },
    IN_USE: {
      value: "IN_USE",
      label: t("HOTDESKING.SEAT_GUIDE.IN_USE"),
      color: "#fea85e",
      hover: "#fa7807",
      blur: "#fea85ecc",
    },
    NOT_USE: {
      value: "NOT_USE",
      label: t("HOTDESKING.SEAT_GUIDE.NOT_USE"),
      color: "#5ee2c3",
      hover: "#00ebb4",
      blur: "#5ee2c3cc",
    },
    NOT_AVAILABLE: {
      value: "NOT_AVAILABLE",
      label: t("HOTDESKING.SEAT_GUIDE.NOT_AVAILABLE"),
      color: "#454545",
      hover: "#454545",
      blur: "#454545cc",
    },
  };
  const formatStatus = (status) => {
    switch (status) {
      case type.AVAILABLE.value:
        return type.AVAILABLE.label;
      case type.NOT_AVAILABLE.value:
        return type.NOT_AVAILABLE.label;
      case type.IN_USE.value:
        return type.IN_USE.label;
      default:
        return type.NOT_USE.label;
    }
  };
  const formatColor = (status) => {
    switch (status) {
      case type.AVAILABLE.value:
        return type.AVAILABLE.color;
      case type.NOT_AVAILABLE.value:
        return type.NOT_AVAILABLE.color;
      case type.IN_USE.value:
        return type.IN_USE.color;
      default:
        return type.NOT_USE.color;
    }
  };
  const formatDate = (date) => {
    return dayjs(new Date(date)).format("YYYY.MM.DD (ddd)");
  };
  const formatTime = (startDttm, endDttm) => {
    const formatStartDttm = dayjs(new Date(startDttm));
    const formatEndDttm = dayjs(new Date(endDttm));
    return (
      <>
        {formatStartDttm.format("HH:mm")} ~ {formatEndDttm.format("HH:mm")}
      </>
    );
  };
  const formatDuration = (duration) => {
    let hours = Math.floor(duration / 60);
    let mins = duration % 60;
    if (i18n.language === "ko-KR") {
      return `${String(hours).padStart(2, "0")}시간 ${String(mins).padStart(
        2,
        "0"
      )}분`;
    } else {
      return `${String(hours).padStart(2, "0")}:${String(mins).padStart(
        2,
        "0"
      )}`;
    }
  };
  return (
    <Popup
      className={`${style.popup} ${style.book}`}
      visible={isOpen}
      onMaskClick={onClose}
    >
      <section className={style.book_section}>
        <section className={style.book_header}>
          <p className={style.header_title}>{resource?.title}</p>
          <div className={style.header_status}>
            <span
              className={style.indicator}
              style={{ backgroundColor: formatColor(book?.status) }}
            />
            <p className={style.label}>{formatStatus(book?.status)}</p>
          </div>
        </section>
        <section className={style.book_content}>
          <section className={style.member_section}>
            <Avatar
              className={style.member_img}
              icon={<UserOutlined className={style.icon} />}
            />
            <section className={style.member_info}>
              <p className={style.member_name}>{book?.member.name}</p>
              <article className={style.member_department}>
                <p>{book?.member.department.name}</p>
                <span className={style.member_divider} />
                <p>{book?.member.role}</p>
              </article>
            </section>
          </section>
          <span className={style.divider} />
          <section className={style.time_section}>
            <div className={style.time_item}>
              <div className={style.time_label}>
                <CalendarIcon />
                <p>{t("HOTDESKING.MODAL.BOOK_INFO.DATE")}</p>
              </div>
              <p className={style.time_content}>
                {formatDate(book?.startDttm)}
              </p>
            </div>
            <div className={style.time_item}>
              <div className={style.time_label}>
                <TimeIcon />
                <p>{t("HOTDESKING.MODAL.BOOK_INFO.TIME")}</p>
              </div>
              <p className={style.time_content}>
                {formatTime(book?.startDttm, book?.endDttm)}(
                {formatDuration(book?.duration)})
              </p>
            </div>
          </section>
        </section>
      </section>
    </Popup>
  );
}

export default BookInfo;
